import React, { useCallback } from 'react';
import styles from './index.module.scss';
import HelperTooltip from '../HelperTooltip';
import cx from 'clsx';

export const IconSwitch = ({
  on,
  onChange,
  onClick,
  tipTitle,
  disabled,
}: {
  on: boolean;
  onChange?: (val: boolean) => void;
  onClick?: () => void;
  tipTitle?: string;
  disabled?: boolean;
}) => {
  const handleCLick = useCallback(() => {
    if (disabled) {
      return;
    }
    onClick?.();
    onChange?.(!on);
  }, [disabled, on, onChange, onClick]);

  return (
    <HelperTooltip title={tipTitle}>
      <div className={cx(styles.container, disabled && styles.disabled)} onClick={handleCLick}>
        <svg
          width="28"
          height="16"
          viewBox="0 0 28 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <rect
            width="28"
            height="16"
            rx="8"
            opacity={`${on ? 1 : 0.3}`}
            fill={on ? 'var(--color-primary)' : 'var(--color-light-blue-title)'}
          />
          <circle cx={on ? '20' : '8'} cy="8" r="6" fill="white" />
        </svg>
      </div>
    </HelperTooltip>
  );
};
